import {JSONAttrs, JSONContent} from '../types';
import {getTextAlign} from '../utils';
import {useBuildContent} from 'hooks/guidebooks/useBuildContent';

type Props = {
  level: number;
  content: JSONContent[];
  attrs?: JSONAttrs;
};

function Heading({level, content, attrs}: Props) {
  const buildedContent = useBuildContent(content);

  switch (level) {
    case 2:
      return <h2 style={{textAlign: getTextAlign(attrs)}}>{buildedContent}</h2>;
    case 3:
      return <h3 style={{textAlign: getTextAlign(attrs)}}>{buildedContent}</h3>;
    default:
      return <h1 style={{textAlign: getTextAlign(attrs)}}>{buildedContent}</h1>;
  }
}

export {Heading};
